// src/config.js

const config = {
  REACT_APP_API_URL: 'https://apix.speed-tunisia.com/api',
  SITE_API_KEY: 'SPNWXYkGQNBwWivrWR64rANPtH278@26KM997yc7jg25c3erBkPMsi7b5PSFneDE8dXWNSP'
  
  };
  
  export default config;
